import { bodyLockRemove, bodyLockAdd } from './functions';
interface City {
    name: string;
    url: string;
}
declare const ymaps: any;

// consts
const CURRENTURL: string = window.location.hostname;
const CURRENTPATH: string = window.location.pathname;

// check geolocation
let allCities: City[] = JSON.parse(localStorage.getItem('allCities') || 'null');

if (!allCities) {
    allCities = [
        { name: "Владивосток", url: "https://vladivostok.centereco.ru" },
        { name: "Волгоград", url: "https://volgograd.centereco.ru" },
        { name: "Воронеж", url: "https://voronezh.centereco.ru" },
        { name: "Екатеринбург", url: "https://ekaterinburg.centereco.ru" },
        { name: "Ижевск", url: "https://izhevsk.centereco.ru" },
        { name: "Иркутск", url: "https://irkutsk.centereco.ru" },
        { name: "Казань", url: "https://kazan.centereco.ru" },
        { name: "Калининград", url: "https://kaliningrad.centereco.ru" },
        { name: "Кемерово", url: "https://kemerovo.centereco.ru" },
        { name: "Краснодар", url: "https://krasnodar.centereco.ru" },
        { name: "Москва", url: "https://moscow.centereco.ru" },
        { name: "Нижний Новгород", url: "https://nn.centereco.ru" },
        { name: "Новосибирск", url: "https://novosibirsk.centereco.ru" },
        { name: "Новый Уренгой", url: "https://n-urengoy.centereco.ru" },
        { name: "Омск", url: "https://omsk.centereco.ru" },
        { name: "Пермь", url: "https://permian.centereco.ru" },
        { name: "Ростов-на-Дону", url: "https://rostov.centereco.ru" },
        { name: "Самара", url: "https://samara.centereco.ru" },
        { name: "Санкт-Петербург", url: "https://centereco.ru" },
        { name: "Севастополь", url: "https://sevastopol.centereco.ru" },
        { name: "Симферополь", url: "https://simferopol.centereco.ru" },
        { name: "Тверь", url: "https://tver.centereco.ru" },
        { name: "Томск", url: "https://tomsk.centereco.ru" },
        { name: "Тула", url: "https://tula.centereco.ru" },
        { name: "Тюмень", url: "https://tyumen.centereco.ru" },
        { name: "Уфа", url: "https://ufa.centereco.ru" },
        { name: "Хабаровск", url: "https://khabarovsk.centereco.ru" },
        { name: "Ханты-Мансийск", url: "https://hanty.centereco.ru" },
        { name: "Челябинск", url: "https://chelyabinsk.centereco.ru" },
        { name: "Ярославль", url: "https://yaroslavl.centereco.ru" }
    ];

    // Caching city data in localStorage
    localStorage.setItem('allCities', JSON.stringify(allCities));
}

// City filtering function
function filterCities(word: string, cities: City[]): City[] {
    const regex = new RegExp(word, 'gi');
    return cities.filter(s => s.name.match(regex));
}

// Retrieve the current city from localStorage
let currentCity: string | null = localStorage.getItem('currentCity');

// Check if currentCity is not saved and the current URL matches
if (!currentCity && CURRENTURL === 'centereco.ru') {
    // Wait for Yandex Maps API to be ready
    ymaps.ready(() => {
        // Get geolocation data
        ymaps.geolocation.get({
            provider: 'yandex',
            autoReverseGeocode: true
        }).then((result: any) => {  // Handle the successful geolocation response
            currentCity = result.geoObjects.get(0).properties.get('metaDataProperty').GeocoderMetaData.text;
            console.log('Успех. Город был определен как - ' + currentCity);

            // Check if the city exists in the database
            if (!filterCities(currentCity, allCities).length) {
                currentCity = 'Санкт-Петербург';
                console.log('Город не найден в базе данных, по умолчанию установлено - ' + currentCity);
            }
            openPopupConfirmCity(currentCity);
        }).catch((err: any) => {  // Handle errors in geolocation
            currentCity = 'Санкт-Петербург'; // Default city
            console.log('Ошибка. Не удалось определить город, используется значение по умолчанию - ' + currentCity);
            openPopupConfirmCity(currentCity);
        });
    });
}

// Function to open a pop-up window with city confirmation
function openPopupConfirmCity(currentCity: string): void {
    const popup = document.querySelector('.popup_what-city');
    const popupCityField = popup?.querySelector('.current-city');
    if (popupCityField) {
        popupCityField.textContent = currentCity;
    }
    if (popup) {
        popup.classList.add('popup_active');
    }
    bodyLockAdd(0);
    localStorage.setItem('currentCity', currentCity);
}

// Find the button to confirm the current city
const buttonConfirmCurrentCity = document.querySelector('.confirm-current-city');

if (buttonConfirmCurrentCity) {
    buttonConfirmCurrentCity.addEventListener('click', () => {
        const cityUrl = filterCities(currentCity as string, allCities);
        if (cityUrl.length && cityUrl[0].url !== CURRENTURL) { // Проверяем, если URL города отличается от текущего URL
            window.location.replace(cityUrl[0].url + window.location.pathname); // Перенаправляем на новый URL
        }
    });
}

// Get references to the DOM elements
const searchCitiesInput = document.querySelector<HTMLInputElement>('.input_select-city');
const searchCitiesField = document.querySelector<HTMLUListElement>('.select-city__list');

// Function to set filtered cities
function setFilteredCities(): void {
    const filteredCities = filterCities(searchCitiesInput.value, allCities);
    let html = '<li class="select-city__item"><p class="select-city__text">Совпадений не найдено</p></li>';
    if (filteredCities.length) {
        html = filteredCities.map(city => {
            return `<li class="select-city__item"><a href="${city.url + CURRENTPATH}" class="select-city__link">${city.name}</a></li>`;
        }).join('');
    }
    searchCitiesField.innerHTML = html;
}

// Check if both elements are found
if (searchCitiesInput && searchCitiesField) {
    // Attach event listeners
    searchCitiesInput.addEventListener('keyup', setFilteredCities);
    searchCitiesInput.addEventListener('change', setFilteredCities);

    // Initial call to set filtered cities
    setFilteredCities();
}